import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const MoonshotAddCampaignDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MoonshotAddCampaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentStep"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currentStep"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentStep"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentStep"}},{"kind":"Field","name":{"kind":"Name","value":"dateDismissed"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"MoonshotAddCampaign","document":MoonshotAddCampaignDocument}} as const;
export type MoonshotAddCampaignMutationVariables = Types.Exact<{
  currentStep: Types.Scalars['String']['input'];
  name: Types.Scalars['String']['input'];
}>;


export type MoonshotAddCampaignMutation = (
  { __typename: 'Mutation' }
  & { addCampaign?: Types.Maybe<(
    { __typename: 'Campaign' }
    & Pick<Types.Campaign, 'id' | 'currentStep' | 'dateDismissed' | 'name'>
  )> }
);

export type MoonshotAddCampaignMutationFn = Apollo.MutationFunction<
  MoonshotAddCampaignMutation,
  MoonshotAddCampaignMutationVariables
>;

/**
 * __useMoonshotAddCampaignMutation__
 *
 * To run a mutation, you first call `useMoonshotAddCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoonshotAddCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moonshotAddCampaignMutation, { data, loading, error }] = useMoonshotAddCampaignMutation({
 *   variables: {
 *      currentStep: // value for 'currentStep'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useMoonshotAddCampaignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MoonshotAddCampaignMutation,
    MoonshotAddCampaignMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MoonshotAddCampaignMutation,
    MoonshotAddCampaignMutationVariables
  >(MoonshotAddCampaignDocument, options);
}
export type MoonshotAddCampaignMutationHookResult = ReturnType<
  typeof useMoonshotAddCampaignMutation
>;
export type MoonshotAddCampaignMutationResult =
  Apollo.MutationResult<MoonshotAddCampaignMutation>;
export type MoonshotAddCampaignMutationOptions = Apollo.BaseMutationOptions<
  MoonshotAddCampaignMutation,
  MoonshotAddCampaignMutationVariables
>;
